import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=0d45c26a&scoped=true"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=0d45c26a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45c26a",
  null
  
)

export default component.exports